export default {
  title: 'Osta e-lahjakortteja',
  subtitle:
    'Sano se lahjakortilla yritykseltä {{companyName}}. Täydellinen syntymäpäiville, kiitokseksi tai ihan vain niin – lunastettavissa joustavasti ruokaan ja juomiin.',
  header: {
    title: 'Lahjakortti',
    subtitle: 'Tuota iloa',
  },
  buttons: {
    buy_now: 'Osta nyt',
  },
};
